/**
 * 论文信息接口列表
 */

// import axios from 'axios';
import axios from '../utils/http';


const publication = {

    // 查询社会兼职数据
    findAllProfessionalActivitiesClient(){
        return axios.get('/professionalActivities/findAllProfessionalActivitiesClient');
    },

    // 查询研究领域
    findAllresearchAreasClient(){
        return axios.get('/researchAreas/findAllresearchAreasClient');
    },

    // 查询论文数据
    findAllPublicationClient(){
        return axios.get('/publication/findAllPublicationClient');
    },

    // 查询出版著作权
    findAllBookClient(){
        return axios.get('/book/findAllBookClient');
    }
    
};

export default publication;

